<form class="max-size-form" [formGroup]="form" (submit)="onSubmit()">

  <button
    type="button"
    class="modal__close"
    (click)="hide.emit()"
    [attr.aria-label]="'Accessibility.aria_close' | translate"
  >
    <span class="ico-close" aria-hidden="true"></span>
  </button>

  <h2 id="otp-modal-title" class="modal__title" tabindex="-1">{{ title ? title : 'OTP.title' | translate }}</h2>
  <p class="modal__text" *ngIf="isLogin">{{ 'OTP.subtitle_first_login' | translate }}</p>
  <p class="modal__text" *ngIf="!isLogin">
    {{ text ? text : 'OTP.subtitle' | translate: { phone: getMaskPhoneNumber(phone$ | async) } }}
  </p>


  <div class="group-input">
    <p class="form-legend">
      {{ 'Common.required_field_prefix' | translate }}
      <span class="asterisk-required" aria-hidden="true">*</span>
      {{ 'Common.required_field_suffix' | translate }}.
    </p>
    <div class="input-text">
      <label for="otp-secretKey">
        {{ 'OTP.placeholder_txt' | translate }}
        <span class="asterisk-required" aria-hidden="true">*</span>
      </label>
      <input
        #otpInput
        id="otp-secretKey"
        formControlName="secretKey"
        type="text"
        maxlength="6"
        [placeholder]="'OTP.placeholder_txt' | translate"
        aria-required="true"
        [attr.aria-invalid]="invalidCode || hasError(form.get('secretKey')) ? true : null"
        [attr.aria-describedby]="invalidCode || hasError(form.get('secretKey')) ? 'otp-error' : null"
        [ngClass]="{ error: invalidCode || hasError(form.get('secretKey')) }"
      />
      <p id="otp-error" class="error-text" *ngIf="invalidCode || hasError(form.get('secretKey'))" role="alert">
        <img class="ico-alert" src="assets/img/ico-error.svg" alt="" aria-hidden="true" />
        {{ invalidCode ? ('OTP.invalid_code' | translate) : ('Common.field_required' | translate) }}
      </p>

    </div>

  </div>

  <a class="new-sms" href="javascript:;" (mousedown)="$event.preventDefault()" (click)="onRepeat()">{{
    email ? ('Transmit.mfs_email_otp_resend' | translate) : (resendText ? resendText : ('OTP.new_message' | translate))
  }}</a>

  <button class="modal__btn btn--primary" type="submit">
    {{ 'Generic.confirm_button' | translate }}
  </button>
</form>
